import StyledControl, { TextFormatLabel } from "../StyledControl";
import markdownToJadle, { isMarkdown } from "../../lib/markdownToJadle";
import { measures, text } from "@quickpoint.me/shared";
import { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { StackCfKeyAtom } from "../../state/stackAtoms";
import { CodeMirrorCodeState } from "../../state/codeAtom";
import FileOpen from "../../icons/file_open.svg?react";
import { IsInPortrait } from "../../state/selectors";
import { MousedOverTextHelper } from "../../state/uiAtoms";
import { fireUpdateCodeEvent } from "../../lib/editor/events";

function MarkdownToJadleControl() {
	const stackCfKey = useRecoilValue(StackCfKeyAtom);
	const code = useRecoilValue(CodeMirrorCodeState(stackCfKey));
	const isInPortrait = useRecoilValue(IsInPortrait);
	const setTextHelper = useSetRecoilState(MousedOverTextHelper);
	const [enabled, setEnabled] = useState(false);

	useEffect(() => {
		setEnabled(isMarkdown(code as string));
	}, [code]);

	const handleClick = () => {
		if (!enabled) return;
		const jadle = markdownToJadle(code as string);
		fireUpdateCodeEvent(jadle);
	};

	const mouseOver = () =>
		setTextHelper(text.textControls.mdToJadle);
	const mouseLeave = () => setTextHelper(undefined);

	// Only show when markdown is detected
	if (!enabled) return null;

	return (
		<StyledControl
			data-testid="md-to-jadle-control"
			$dim={false}
			$isInPortrait={isInPortrait}
			onClick={handleClick}
			onMouseOver={mouseOver}
			onMouseLeave={mouseLeave}
			aria-label={text.textControls.mdToJadle}
			$height={measures.textControlBar.controlIcon}
			$iconHeight={
				isInPortrait
					? measures.textControlBar.portrait.controlButton
					: measures.textControlBar.landscape.controlButton
			}
			$glow={true}
		>
			{!isInPortrait && (
				<FileOpen
					aria-hidden="true"
					focusable="false"
					className="text-control md"
				/>
			)}
			{!isInPortrait && <TextFormatLabel>MD</TextFormatLabel>}
			{isInPortrait && (
				<FileOpen
					aria-hidden="true"
					focusable="false"
					className="text-control md"
				/>
			)}
		</StyledControl>
	);
}

export default MarkdownToJadleControl;
